import type { ProSearchData } from '@application/utils';
import type { CardItemProSmallData } from '@presentation/components';
import type { LocationDescriptor } from 'history';

export interface ProLandingPageProps {
  vetItems?: CardItemProSmallData[];
  groomerItems?: CardItemProSmallData[];

  vetItemsLoading?: boolean;
  groomerItemsLoading?: boolean;

  joinProLink: LocationDescriptor;
  moreVetsLink: LocationDescriptor;
  moreGroomersLink: LocationDescriptor;

  proSearch: ProSearchData;
}
